import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { useAuthGuard } from "../hooks/useAuthGuard";
import { useSessionKeepAlive } from "../hooks/useSessionKeepAlive";

export default function Layout() {
    useAuthGuard();           // asegúrate de invocarlo
    useSessionKeepAlive();    // aquí renovamos la cookie cada 3 mins

    return (
        <div className="flex">
            <Sidebar />
            <div className="flex-1 bg-gray-100 min-h-screen p-4">
                <Header />
                <Outlet />
            </div>
        </div>
    );
}
